module.exports = __webpack_public_path__ + "16e7b3df8d7389dac30cf658dc91f45f.png";